module.exports = __webpack_public_path__ + "static/datamanNextL-231bf42ecde9743845468bb4c7cfa6b2.png";